import { render, staticRenderFns } from "./expense-category.vue?vue&type=template&id=66ae1540&scoped=true&"
import script from "./expense-category.vue?vue&type=script&lang=js&"
export * from "./expense-category.vue?vue&type=script&lang=js&"
import style0 from "./expense-category.vue?vue&type=style&index=0&id=66ae1540&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ae1540",
  null
  
)

export default component.exports